const TRUCK_ROUTES = '@@TRUCK_ROUTES@@/'

export const TRUCK_ROUTES_CHANGE = `${TRUCK_ROUTES}TRUCK_ROUTES_CHANGE`
export const STOP_NUMBER_CHANGE = `${TRUCK_ROUTES}STOP_NUMBER_CHANGE`
export const CLEAR_TRUCK_ROUTE = `${TRUCK_ROUTES}CLEAR_TRUCK_ROUTE`
